import {AfterViewInit, Component, Input, OnDestroy, OnInit, Output, ViewChild, EventEmitter} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {debounceTime, delay, first, skipUntil, startWith, takeUntil, tap} from 'rxjs/operators';
import {BehaviorSubject, of, ReplaySubject} from 'rxjs';
import {validPesel} from '../../../shared/validator/pesel-validator';
import {PeselHelperService} from '../../../shared/services/pesel-helper.service';
import {
  DICT_TYPE_SEX,
  DictService,
  SEX_FEMALE,
  SEX_MALE,
  DICT_TYPE_TEMPLATE_TYPE,
  TEMPLATE_TYPE_PERSONAL_DATA_CHANGE,
} from '../../../shared/services/dict.service';
import {validPhoneNumber} from '../../../shared/validator/phone-validator';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Uuid} from '../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {OfwcaService} from '../../../shared/services/ofwca.service';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {Ofwca, OfwcaRau} from '../../../shared/interface/ofwca';
import {DictPartnersComponent} from '../../../shared/components/dict-partners/dict-partners.component';
import {Router} from '@angular/router';
import {PartnerFacility} from '../../../shared/interface/partner-facility';
import {Partner} from '../../../shared/interface/partner';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {OfwcaAddDialogComponent} from '../ofwca-add-dialog/ofwca-add-dialog.component';
import moment, {isMoment, Moment} from 'moment';
import {Profile} from '../../../shared/interface/profile';
import {AuthService} from '../../../shared/services/auth.service';
import {FacilityAddDialogComponent} from '../../facilities/facility-add-dialog/facility-add-dialog.component';
import {PartnerService} from '../../../shared/services/partner.service';
import {validIban} from "../../../shared/validator/iban-validator";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {TemplateService} from "../../../shared/services/template.service";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {validEmailAddress} from "../../../shared/validator/email-validator";
import {EmailAddress} from "../../../shared/interface/email-address";
import {ArrayValidators} from "../../../shared/validator/array-validators";
import {PhoneNumber} from "../../../shared/interface/phone-number";
import * as uuid from 'uuid';

@Component({
  selector: 'app-ofwca-add',
  templateUrl: './ofwca-add.component.html',
  styleUrls: ['./ofwca-add.component.scss'],
})
export class OfwcaAddComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() ofwca?: ReplaySubject<Ofwca>;
  @Input() partnerObject?: Partner = null;
  @Input() facilityObject?: PartnerFacility = null;
  @Input() dialogRef?: MatDialogRef<OfwcaAddDialogComponent> = null;
  @Output() ofwcaCreated = new EventEmitter<string>();
  @ViewChild(DictPartnersComponent) dictPartners;
  @Output() closeModification = new EventEmitter<any>();

   readonly SEX_FEMALE = SEX_FEMALE;


  userPermissions: ReplaySubject<UserPermissions>;
  userPermissionss: UserPermissions;
  ofwcaObject?: Ofwca = null;
  processingRequest = false;
  enableSaveButton = false;
  requireFullDataFields = false;
  partnerId: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  formErrors: any = {};
  ofwcaForm: FormGroup;
  productEmailSameAsPrimary: boolean;
  contestEmailSameAsPrimary: boolean;
  krkRequestedByOfwca = false;
  partners: Partner[] = [];
  accountNumberControl: FormControl;
  generatingDocument = false;
  maternityLeave = false;
  mainEmails:  FormGroup[] = [];
  additionalEmails:  FormGroup[] = [];
  mainPhones:  FormGroup[] = [];
  additionalPhones:  FormGroup[] = [];

  constructor(
    private fb: FormBuilder,
    private peselHelper: PeselHelperService,
    private dictService: DictService,
    private snack: MatSnackBar,
    private ofwcaService: OfwcaService,
    private formHelper: FormHelperService,
    private router: Router,
    private auth: AuthService,
    private partnerService: PartnerService,
    private dialog: MatDialog,
    private templateService: TemplateService,
  ) {
    this.userPermissions = this.auth.getUserPermissions();
    this.ofwcaForm = this.fb.group({
      firstName: this.fb.control('', [Validators.required]),
      secondName: this.fb.control(''),
      lastName: this.fb.control('', [Validators.required]),
      pesel: this.fb.control('', [Validators.required, validPesel()]),
      livingAddressSameAsRegistered: this.fb.control(true),
      communicationAddressSameAsRegistered: this.fb.control(false),
      communicationAddressSameAsLiving: this.fb.control(false),
      documentType: this.fb.control('', []),
      documentNumber: this.fb.control('', []),
      documentIssueDate: this.fb.control('', []),
      documentExpirationDate: this.fb.control('', []),
      documentIssuer: this.fb.control('', []),
      withoutPesel: this.fb.control(false),
      familyName: this.fb.control(''),
      citizenship: this.fb.control('', [Validators.required]),
      mothersMaidenName: this.fb.control(''),
      mothersName: this.fb.control(''),
      fathersName: this.fb.control(''),
      birthPlace: this.fb.control(''),
      birthDate: this.fb.control('', [Validators.required]),
      sex: this.fb.control('', [Validators.required]),
      education: this.fb.control('', [Validators.required]),
      registeredAddress: this.formHelper.generateAddressFormGroup(),
      livingAddress: this.formHelper.generateAddressFormGroup(),
      communicationAddress: this.formHelper.generateAddressFormGroup(),
      partner: this.fb.control(''),
      facility: this.fb.control(''),
      productMessageConsent: this.fb.control(false),
      contestMessageConsent: this.fb.control(false),
      hiperioGrantingAccess: this.fb.control(false),
      hiperioEmail: this.fb.control('', [validEmailAddress()]),
      hiperioAutomaticAccessUpdate: this.fb.control(false),
      verified: fb.control(true),
      withoutAddress: fb.control(false),
      note: fb.control(''),
      profitNumber: fb.control(''),
      krkRequestedByOfwca: fb.control(false),
      rauNumbers: fb.control([]),
      firstKnfEntry: fb.control(''),
      accountNumber: this.accountNumberControl = fb.control('', [validIban()]),
      companyOwner: this.fb.control(''),
      settlementSendBlockAsf: fb.control(false),
      settlementSendBlockPremium: fb.control(false),
      billAddBlockAsf: fb.control(false),
      billAddBlockPremium: fb.control(false),
      maternityLeaveFrom:  fb.control(''),
      maternityLeaveTo: fb.control(''),
      mainEmails:  fb.array(this.mainEmails, [ArrayValidators.minLength(1)]),
      additionalEmails: fb.array(this.additionalEmails),
      mainPhones:  fb.array(this.mainPhones, [ArrayValidators.minLength(1)]),
      additionalPhones: fb.array(this.additionalPhones),
    });
  }

  public getControl(name: string): FormControl {
    return this.ofwcaForm.get(name) as FormControl;
  }

  public getGroup(name: string): FormGroup {
    return this.ofwcaForm.get(name) as FormGroup;
  }

  ngOnInit(): void {
    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissionss = userPermissions;
      });

    this.ofwcaForm.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        delay(0),
        tap(() => this.enableSaveButton = this.ofwcaForm.valid)
      )
      .subscribe();

    this.ofwcaForm.get('withoutPesel').valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((withoutPesel: boolean) => this.updatePeselControl(withoutPesel));

    this.ofwcaForm.get('maternityLeaveFrom').valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val) =>
      {
        if (this.ofwcaForm.get('maternityLeaveTo').value || this.ofwcaForm.get('maternityLeaveFrom').value){
          this.ofwcaForm.get('maternityLeaveTo').setValidators([Validators.required]);
          this.ofwcaForm.get('maternityLeaveFrom').setValidators([Validators.required]);
          this.maternityLeave = true;
        } else {
          this.ofwcaForm.get('maternityLeaveTo').setValidators([]);
          this.ofwcaForm.get('maternityLeaveFrom').setValidators([]);
          this.maternityLeave = false;
        }

      });

    this.ofwcaForm.get('maternityLeaveTo').valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val) =>
      {
        if (this.ofwcaForm.get('maternityLeaveTo').value || this.ofwcaForm.get('maternityLeaveFrom').value){
          this.ofwcaForm.get('maternityLeaveTo').setValidators([Validators.required]);
          this.ofwcaForm.get('maternityLeaveFrom').setValidators([Validators.required]);
          this.maternityLeave = true;
        } else {
          this.ofwcaForm.get('maternityLeaveTo').setValidators([]);
          this.ofwcaForm.get('maternityLeaveFrom').setValidators([]);
          this.maternityLeave = false;
        }
      });


    this.ofwcaForm.get('pesel').valueChanges
      .pipe(
        debounceTime(400),
        takeUntil(this.destroyed$),
        skipUntil(this.initialized)
      )
      .subscribe((pesel: string) => this.updateDataBasedOnPesel(pesel));

    this.ofwcaForm.get('livingAddressSameAsRegistered').valueChanges
      .pipe(
        startWith(true),
        takeUntil(this.destroyed$)
      )
      .subscribe((livingAddressSameAsRegistered: boolean) => {
        livingAddressSameAsRegistered ? this.getGroup('livingAddress').disable() : this.getGroup('livingAddress').enable();
      });

    this.ofwcaForm.get('communicationAddressSameAsRegistered').valueChanges
      .pipe(
        startWith(false),
        takeUntil(this.destroyed$)
      )
      .subscribe((communicationAddressSameAsRegistered: boolean) => {
        if (communicationAddressSameAsRegistered){
          this.ofwcaForm.get('communicationAddressSameAsLiving').setValue(false);
        }
        communicationAddressSameAsRegistered ? this.getGroup('communicationAddress').disable()
          : this.getGroup('communicationAddress').enable();
      });

    this.ofwcaForm.get('communicationAddressSameAsLiving').valueChanges
      .pipe(
        startWith(false),
        takeUntil(this.destroyed$)
      )
      .subscribe((communicationAddressSameAsLiving: boolean) => {
        if (communicationAddressSameAsLiving){
          this.ofwcaForm.get('communicationAddressSameAsRegistered').setValue(false);
        }
        communicationAddressSameAsLiving ? this.getGroup('communicationAddress').disable()
          : this.getGroup('communicationAddress').enable();
      });

    this.ofwcaForm.get('withoutAddress').valueChanges
      .pipe(
        startWith(false),
        takeUntil(this.destroyed$)
      ).subscribe((withoutAddress: boolean) => {
        if (!withoutAddress) {
          this.ofwcaForm.get('registeredAddress').enable();
        } else {
          this.ofwcaForm.get('registeredAddress').disable();
        }
    });

    this.getControl('partner').valueChanges
      .pipe(
        startWith(''),
        takeUntil(this.destroyed$)
      )
      .subscribe((partnerId: string) => {
        if (this.partnerObject || this.facilityObject) {
          return;
        }

        if (!partnerId) {
          this.getControl('facility').disable();
        } else {
          this.getControl('facility').enable();
          this.partnerId.next(partnerId);
          this.getControl('facility').reset();
        }
      });

    this.getControl('documentIssueDate').valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        skipUntil(this.initialized)
      )
      .subscribe((val: Moment) => {
        if (!val || !isMoment(val)) {
          return;
        }

        this.getControl('documentExpirationDate').setValue(val.clone().add(10, 'years'));
      });

    this.ofwcaForm.get('productEmailSameAsPrimary').valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        startWith(true)
      )
      .subscribe((val: boolean) => this.productEmailSameAsPrimary = val);

    this.ofwcaForm.get('contestEmailSameAsPrimary').valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        startWith(true)
      )
      .subscribe((val: boolean) => this.contestEmailSameAsPrimary = val);

    this.ofwcaForm.get('email').valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((email: string) => {
        if (this.productEmailSameAsPrimary) {
          this.ofwcaForm.get('productEmail').setValue(email);
        }
        if (this.contestEmailSameAsPrimary) {
          this.ofwcaForm.get('contestEmail').setValue(email);
        }
    });

    this.ofwcaForm.get('krkRequestedByOfwca').valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((val: boolean) => {
        this.krkRequestedByOfwca = val;

        if (this.ofwcaObject && this.ofwcaObject.excelId) {
          return;
        }
    });

    if (this.partnerObject) {
      this.getControl('partner').setValue(this.partnerObject.uuid);
      this.partnerId.next(this.partnerObject.uuid);
    }

    if (this.facilityObject) {
      this.getControl('facility').setValue(this.facilityObject.id);
      this.partners = this.facilityObject.partners;

      if (this.facilityObject.partners.length === 1) {

        this.getControl('partner').setValue(this.facilityObject.partners[0].uuid);
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.ofwca) {
      this.ofwca.pipe(
        first(),
        delay(0)
      )
        .subscribe((ofwca: Ofwca) => {
          this.ofwcaObject = ofwca;
          this.initialize(ofwca);
          if (!ofwca.excelId) {
            this.requireFullData();
          }
        });
    } else {
      this.requireFullData();
      this.addEmail('mainEmails');
      this.addPhone('mainPhones');
      this.initialized.next(true);
    }
  }

  requireFullData(): void {
    of('')
      .pipe(
        delay(0)
      ).subscribe(() => {
        ['familyName', 'mothersMaidenName', 'mothersName', 'fathersName', 'birthPlace'].forEach((el: string) => {
          this.ofwcaForm.get(el).setValidators([Validators.required]);
        });
        this.ofwcaForm.get('withoutAddress').setValue(false);

        this.requireFullDataFields = true;
    });
  }

  initialize(ofwca: Ofwca): void {
    of(ofwca)
      .pipe(
        tap(() => {
          this.mainEmails = [];
          this.additionalEmails = [];

          this.mainPhones = [];
          this.additionalPhones = [];

          this.ofwcaForm.reset({
            firstName: ofwca.firstName,
            secondName: ofwca.secondName,
            lastName: ofwca.lastName,
            pesel: ofwca.pesel,
            withoutPesel: !ofwca.pesel,
            familyName: ofwca.familyName,
            citizenship: ofwca.citizenship,
            mothersMaidenName: ofwca.mothersMaidenName,
            mothersName: ofwca.mothersName,
            fathersName: ofwca.fathersName,
            birthPlace: ofwca.birthPlace,
            birthDate: ofwca.birthDate ? moment(ofwca.birthDate) : '',
            sex: ofwca.sex?.id || '',
            education: ofwca.education?.id || '',
            documentType: ofwca.documentType?.id || '',
            documentIssuer: ofwca.documentIssuer,
            documentNumber: ofwca.documentNumber,
            documentIssueDate: ofwca.documentIssueDate ? moment(ofwca.documentIssueDate) : '',
            documentExpirationDate: '',
            partner: ofwca.partner?.uuid || '',
            livingAddressSameAsRegistered: ofwca.registeredAddress?.uuid === ofwca.livingAddress?.uuid,
            communicationAddressSameAsRegistered: ofwca.registeredAddress?.uuid === ofwca.communicationAddress?.uuid,
            communicationAddressSameAsLiving: ofwca.livingAddress?.uuid === ofwca.communicationAddress?.uuid,
            productMessageConsent: ofwca.productMessageConsent,
            contestMessageConsent: ofwca.contestMessageConsent,
            hiperioGrantingAccess: ofwca.hiperioGrantingAccess,
            hiperioEmail: ofwca.hiperioEmail,
            hiperioAutomaticAccessUpdate: ofwca.hiperioAutomaticAccessUpdate,
            verified: ofwca.verified,
            withoutAddress: ofwca.withoutAddress,
            note: ofwca.note,
            krkRequestedByOfwca: ofwca.krkRequestedByOfwca,
            rauNumbers: ofwca.rauNumbers.map((ofwcaRau: OfwcaRau) => ofwcaRau.rau),
            firstKnfEntry: ofwca.firstKnfEntry,
            accountNumber: ofwca.accountNumber,
            companyOwner: ofwca.companyOwner?.uuid,
            settlementSendBlockAsf: ofwca.settlementSendBlockAsf,
            settlementSendBlockPremium: ofwca.settlementSendBlockPremium,
            billAddBlockAsf: ofwca.billAddBlockAsf,
            billAddBlockPremium: ofwca.billAddBlockPremium,
            maternityLeaveFrom:  ofwca.maternityLeaveFrom,
            maternityLeaveTo: ofwca.maternityLeaveTo
          });

          ofwca.emails.filter((email: EmailAddress) => email.main)
            .forEach((email: EmailAddress) => this.addEmail('mainEmails', email.uuid, email.address, email.name,
              email.marketing, email.product));
          ofwca.emails.filter((email: EmailAddress) => !email.main)
            .forEach((email: EmailAddress) => this.addEmail('additionalEmails', email.uuid, email.address,
              email.name, email.marketing, email.product));

          ofwca.phones.filter((phoneNumber: PhoneNumber) => phoneNumber.main)
            .forEach((phoneNumber: PhoneNumber) => this.addPhone('mainPhones', phoneNumber.uuid, phoneNumber.number, phoneNumber.name,
              phoneNumber.marketing, phoneNumber.product));
          ofwca.phones.filter((phoneNumber: PhoneNumber) => !phoneNumber.main)
            .forEach((phoneNumber: PhoneNumber) => this.addPhone('additionalPhones', phoneNumber.uuid, phoneNumber.number,
              phoneNumber.name, phoneNumber.marketing, phoneNumber.product));


          if (ofwca.accountNumber){
            this.ofwcaForm.get('accountNumber').disable();
          }

        }),
        delay(0),
        tap(() => {
          if (ofwca.documentExpirationDate) {
            this.ofwcaForm.get('documentExpirationDate').setValue(moment(ofwca.documentExpirationDate));
          }

          this.ofwcaForm.get('facility').setValue(ofwca.facility?.id);

          if (ofwca.withoutAddress) {
            return;
          }

          this.formHelper.setAddress(ofwca.registeredAddress, this.getGroup('registeredAddress'));
          this.formHelper.setAddress(ofwca.livingAddress, this.getGroup('livingAddress'));
          this.formHelper.setAddress(ofwca.communicationAddress, this.getGroup('communicationAddress'));
        }),
        delay(0),
        tap(() => {
          this.ofwcaForm.markAllAsTouched();
          this.initialized.next(true);
        })
      ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  updatePeselControl(withoutPesel: boolean): void {
    const peselControl = this.ofwcaForm.get('pesel');

    if (withoutPesel) {
      peselControl.reset();
      peselControl.setValidators([]);
      peselControl.disable();
    } else {
      peselControl.setValidators([Validators.required]);
      peselControl.enable();
    }
  }

  updateDataBasedOnPesel(pesel?: string): void {
    if (!pesel) {
      return;
    }

    const result = this.peselHelper.decode(pesel);
    if (result.valid) {
      this.getControl('birthDate').setValue(result.birthDate);
      this.dictService.getId(result.male ? SEX_MALE : SEX_FEMALE, DICT_TYPE_SEX)
        .subscribe((val: number) => this.getControl('sex').setValue(val));
    }
  }

  sendForm(): void {
    if (this.ofwcaForm.get('accountNumber').value === 'PL' ){
      this.ofwcaForm.get('accountNumber').reset();
    }
    if (!this.ofwcaForm.valid) {
      this.ofwcaForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.ofwcaForm, this.formErrors);
    this.formErrors = {};

    this.ofwcaService.sendForm(this.ofwcaForm.getRawValue(), this.ofwcaObject ? this.ofwcaObject.uuid : null)
      .pipe(
        first()
      )
      .subscribe((response: any) => {
        this.snack.open(this.ofwcaObject ? 'Pomyślnie zaktualizowano obiekt OFWCA'
          : 'Pomyślnie utworzono obiekt OFWCA', '', {
          duration: 2000,
        });
        if (!response.jobUuid){
          this.processingRequest = false;
        }
        if (response.jobUuid) {
          this.processingRequest = true;
          this.generatePersonalDataChange();
        }

        if (this.partnerObject || this.dialogRef) {
          this.ofwcaCreated.emit(response.uuid);
        } else if (!this.ofwcaObject) {
          this.router.navigate(['/ofwca/szczegoly', response.uuid]);
        } else if (!response.jobUuid) {
          this.closeModification.emit();
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        if (error.status === 404) {
          this.snack.open('Rekord został usunięty lub przeniesiony', error.status.toString(), {
            duration: 2000,
          });
          this.router.navigate(['/ofwca']);
          return;
        }
        if (error?.error?.error?.text){
          this.snack.open(error?.error.error.text, error.status.toString(), {
            duration: 2000,
          });
        } else {
          this.snack.open(this.ofwcaObject ? 'Podczas aktualizacji obiektu OFWCA wystąpił błąd'
            : 'Podczas tworzenia obiektu OFWCA wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });
        }

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.ofwcaForm, this.formErrors);
        }
      })
    ;
  }

  cancel(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      return;
    }

    if (!this.ofwcaObject) {
      this.router.navigate(['/ofwca']);
    } else {
      this.closeModification.emit();
    }
  }

  addFacility(): void {
    this.partnerId.pipe(first())
      .subscribe((partnerId: string) => {
        this.partnerService.get(partnerId)
          .subscribe((partner: Partner) => {
            const dialogRef = this.dialog.open(FacilityAddDialogComponent, {
              width: '600px',
              data: {partner: partner},
              height: '90%',
              maxHeight: '2000px',
            });

            dialogRef.afterClosed().subscribe(() => {
              this.partnerId.next(partnerId);
            });
          });
      });
  }

  generatePersonalDataChange(): void {
    this.dictService.getId(TEMPLATE_TYPE_PERSONAL_DATA_CHANGE, DICT_TYPE_TEMPLATE_TYPE)
      .subscribe((dictId: number) => {
        this.templateService.generate({
          type: dictId,
          ofwca: this.ofwcaObject.uuid,
        }).subscribe((response: Uuid) => {
          const dialogRef = this.dialog.open(JobResultDialogComponent, {
            disableClose: true,
            width: '500px',
            data: {jobId: response.uuid, showProgress: false},
          });

          dialogRef.afterClosed().subscribe(result => {
            this.processingRequest = false;
            this.closeModification.emit();
          });
        }, (error: HttpErrorResponse) => {
          this.generatingDocument = false;
          if (error.status === 404) {
            this.snack.open('Brak szablonów dla tego typu dokumentu', '', {duration: 2000});
            return;
          }

          this.snack.open('Przy generowaniu dokumentów wystąpił błąd', error.status.toString(), {duration: 2000});
        });
      });
  }

  removePhone(i: number, type: string): void {
    this[type].splice(i, 1);
    this.refreshPhoneControl(type);
  }

  refreshPhoneControl(type: string): void {
    const validators = type === 'mainPhones' ? [ArrayValidators.minLength(1)] : [];
    this.ofwcaForm.setControl(type, this.fb.array(this[type], validators));
  }

  addPhone(type: string, recordUuid?: string, phone?: string, name?: string, marketing: boolean = false, product: boolean = false): void {
    this[type].push(this.fb.group({
      uuid: this.fb.control(recordUuid ?? uuid.v4(), [Validators.required]),
      phone: this.fb.control(phone ?? '', [Validators.required, validPhoneNumber()]),
      name: this.fb.control(name ?? ''),
      marketing: this.fb.control(marketing ?? ''),
      product: this.fb.control(product ?? ''),
    }));
    this.refreshPhoneControl(type);
  }


  removeEmail(i: number, type: string): void {
    this[type].splice(i, 1);
    this.refreshEmailControl(type);
  }

  refreshEmailControl(type: string): void {
    const validators = type === 'mainEmails' ? [ArrayValidators.minLength(1)] : [];
    this.ofwcaForm.setControl(type, this.fb.array(this[type], validators));
  }

  addEmail(type: string, recordUuid?: string, email?: string, name?: string, marketing: boolean = false, product: boolean = false): void {
    this[type].push(this.fb.group({
      uuid: this.fb.control(recordUuid ?? uuid.v4(), [Validators.required]),
      email: this.fb.control(email ?? '', [Validators.required, Validators.email]),
      name: this.fb.control(name ?? ''),
      marketing: this.fb.control(marketing ?? ''),
      product: this.fb.control(product ?? ''),
    }));
    this.refreshEmailControl(type);
  }

}
